const about = {
  // HeroSection (from aboutData)
  'about.hero.homeLink': 'ホーム',
  'about.hero.currentPage': 'アカデミーについて',
  'about.hero.title': 'アカデミーについて',
  'about.hero.titleEn': 'ABOUT THE ACADEMY',
  'about.hero.lead': '日本執事アカデミーは、全日本執事協会が運営する日本で唯一の本格的な執事育成機関です。英国執事の伝統を受け継ぐ日本の執事学校・バトラー養成機関として、動ける執事を育てています。',
  'about.hero.badge1': '一般社団法人 全日本執事協会 運営',
  'about.hero.badge2': '東京・お台場に校舎を構える',
  'about.hero.badge3': '土日開催・定員6名の少人数制',
  'about.hero.imgAlt': 'エントランスホールで来客を丁寧に出迎える日本人男性執事と女性執事の様子',
  'about.us.imgAlt': '教室で受講生に所作を指導する講師',

  // AboutUs section
  'about.us.label': 'OUR STORY',
  'about.us.title': '日本執事アカデミーとはどんな学校？',
  'about.us.subtitleEn': 'About The Japan Butler Academy',
  'about.us.lead': '伝統的な執事の技能と現代のニーズを融合させた、日本で唯一の本格的な執事育成機関です。英国執事の伝統と日本のおもてなしを融合させた日本の執事学校として、私たちは「動ける執事」を育てます。',
  'about.us.h3.1': '日本執事アカデミーが目指すもの',
  'about.us.para1': '執事は、ただ家事をこなす職業ではありません。先を読み、場を整え、相手が口にする前に動く——その技術と心構えを体系立てて学べる場として、日本執事アカデミーは生まれました。',
  'about.us.h3.2': '実技中心・完全少人数の学び方',
  'about.us.para2': '伝統的な執事の技能と現代のサービス業界が求める実践力を融合させた独自のカリキュラムにより、座学にとどまらない「動ける執事」を育成します。授業は実技を中心に構成され、受講生の皆様一人ひとりに講師の目が行き届く完全少人数制（定員6名）を採用。お仕事を続けながら学べるよう、すべての授業を土日に開催しています。',
  'about.us.h3.3': '体系的な3段階コースと現場経験豊かな講師陣',
  'about.us.para3': 'カリキュラムはエッセンシャル・アドバンス・マスターの3段階構成で、上位コースほど下位コースの内容を含みます。目的に応じて1つのコースをお選びいただくだけで、基礎から応用、そして管理と危機対応までを体系的に学べます。',
  'about.us.para4': '講師陣は、国内外の現場で執事としての経験を積んだプロフェッショナルです。実務で培った所作と判断力を、体系化された「型」としてお伝えし、修了後すぐに現場で活かせる力を育みます。',
  'about.us.h3.4': '全日本執事協会が監修する体系的な教科書とお台場の学び舎',
  'about.us.h3.4a': '全日本執事協会が監修する体系的な教科書',
  'about.us.h3.4b': 'お台場の学び舎',
  'about.us.para5': '学びの土台となるのは、全日本執事協会が監修するモジュール式の専門教科書（基礎・応用・専門の各シリーズ）です。執事学入門やハウスキーピングといった基礎から、家政管理・食事サービス・イベント企画などの応用、国際プロトコルや危機管理まで——執事に求められる知識と技能を段階的に積み上げられるよう、体系立てて編まれています。修了後も手元で参照できる教材として、継続的な学びを支えます。',
  'about.us.para6': '対面授業は東京・お台場の本校で行います。高級ホテルのロビーを思わせる品格ある環境で、ティーサービスやテーブルセッティング、エスコートの所作を実際に体を動かしながら習得します。あわせて、予習・復習用のオンデマンド動画講座を組み合わせたハイブリッド学習により、限られた対面時間を実技と質疑応答に集中して使える設計としています。',

  // FourFeatures section
  'about.features.label': 'OUR STRENGTHS',
  'about.features.title': '4つの特長',
  'about.features.subtitleEn': 'Four Pillars of Our Education',
  'about.features.lead': '私たちの教育は、四つの柱で支えられています。少人数だからこその密度、体系化された教材、目標となる認定資格、そして働きながら学べる開催形態です。',
  'about.features.1.title': '実践重視の少人数教育',
  'about.features.1.desc': '定員6名の完全少人数制。実技中心のカリキュラムにより、講師が受講生一人ひとりの所作を細部まで確認し、確実な習得へと導きます。座学で終わらせず、「体が覚えるまで」繰り返すことを大切にしています。一人ひとりの理解度に合わせて講師が目を配れるよう、最少催行は3名としています。',
  'about.features.2.title': '体系化されたカリキュラムと教材',
  'about.features.2.desc': '伝統的な執事技能を現代のニーズに合わせて再編し、段階的に学べる教材として体系化。なぜその所作が必要なのか——理論と実践の両面から理解を深め、応用力を養います。教材は全日本執事協会が監修するモジュール式の専門教科書（基礎・応用・専門の各シリーズ）として整備され、コースに応じて段階的に学べます。',
  'about.features.3.title': '協会認定資格への道',
  'about.features.3.desc': '所定の課程を修了し審査に合格することで、全日本執事協会認定のバトラー資格を取得できます。プロフェッショナルとしての信頼の証であり、キャリア形成の基盤となる資格です。',
  'about.features.4.title': '働きながら学べる土日開催',
  'about.features.4.desc': 'すべての授業を土日に開催。現職を離れることなく、週末を活用して専門性を高められます。転職や独立を見据えたキャリアアップの選択肢として、働きながら学べる環境をご用意しています。土日の対面授業に予習・復習用のオンデマンド動画を組み合わせたハイブリッド形式で、限られた時間でも着実に学びを深められます。',

  // AcademyOverview section
  'about.overview.label': 'EXPLORE',
  'about.overview.title': 'アカデミーの全体像',
  'about.overview.subtitleEn': 'The Full Picture',
  'about.overview.lead': '各ページで、アカデミーの理念から施設、コースまでを詳しくご紹介しています。知りたい情報からお進みください。',
  'about.overview.viewLink': '詳しく見る',
  'about.overview.link1.title': '教育理念・方針',
  'about.overview.link1.desc': '私たちが大切にする教育の考え方',
  'about.overview.link2.title': '全日本執事協会について',
  'about.overview.link2.desc': '運営母体と提供する事業のご紹介',
  'about.overview.link3.title': '施設・設備紹介',
  'about.overview.link3.desc': 'お台場の本校と実習環境',
  'about.overview.link4.title': 'アクセス',
  'about.overview.link4.desc': '校舎への行き方と完全予約制のご案内',
  'about.overview.link5.title': 'コース一覧・比較',
  'about.overview.link5.desc': '3つのコースの違いを一覧で確認',
  'about.overview.link6.title': 'カリキュラム概要',
  'about.overview.link6.desc': '学びの全体像と進め方',

  // CoursesOverview section
  'about.courses.label': 'COURSES',
  'about.courses.title': '3つのコース',
  'about.courses.subtitleEn': 'Three Learning Paths',
  'about.courses.lead': '学びの段階に応じて、三つのコースをご用意しています。基礎を固めるエッセンシャルから、管理と危機対応までを修めるマスターまで、目的に合わせてお選びいただけます。',
  'about.courses.periodLabel': '期間',
  'about.courses.daysLabel': '授業日数',
  'about.courses.hoursLabel': '総時間',
  'about.courses.priceLabel': '料金',
  'about.courses.currency': '円',
  'about.courses.taxNote': '（税込）',
  'about.courses.viewDetail': 'コース詳細を見る',
  'about.courses.viewAll': 'コース一覧・比較ページへ',
  'about.courses.recommended': 'RECOMMENDED',
  'about.courses.essential.title': 'エッセンシャル',
  'about.courses.essential.duration': '1ヶ月',
  'about.courses.essential.days': '全8日間',
  'about.courses.essential.hours': '48時間',
  'about.courses.essential.description': '執事の基本所作と接遇の型を集中的に学ぶ入門コース。おもてなしの基礎を確実に身につけ、サービス業でのキャリアアップを目指す方に最適です。',
  'about.courses.advanced.title': 'アドバンス',
  'about.courses.advanced.duration': '2ヶ月',
  'about.courses.advanced.days': '全12日間',
  'about.courses.advanced.hours': '72時間',
  'about.courses.advanced.description': 'エッセンシャルの全内容を含んだ上で、本物のサービスをゲストとして体験する特別実習やより高度な接遇技術まで習得する中級コース。未経験からの直接受講も可能で、働きながら専門性を高められる設計です。',
  'about.courses.master.title': 'マスター',
  'about.courses.master.duration': '3ヶ月',
  'about.courses.master.days': '全16日間',
  'about.courses.master.hours': '96時間',
  'about.courses.master.description': 'エッセンシャル・アドバンスの全内容を含んだ上で、管理・危機対応までを網羅する最上級コース。未経験からの直接受講も可能で、執事としての総合力を完成させます。',

  // CorporateSection (about page)
  'about.corporate.label': 'FOR CORPORATIONS',
  'about.corporate.title': '法人・団体の皆様へ',
  'about.corporate.body': '企業向けの接遇・ビジネスマナー研修も承っています。',
  'about.corporate.note': 'プロの執事が培った接遇スキルに基づく、教育レベルのビジネスマナー研修です（執事資格を付与するものではありません）。',
  'about.corporate.cta': '法人研修を見る',

  // FAQ section
  'about.faq.label': 'FAQ',
  'about.faq.title': 'よくあるご質問',
  'about.faq.subtitleEn': 'Frequently Asked Questions',
  'about.faq.footer': 'その他のご質問はフォームよりお寄せください',
  'about.faq.q1': 'どんな人が対象ですか？',
  'about.faq.a1': '初心者からプロ志望の方まで対象です。上位コースは下位コースの内容を含むため、目的に応じて1つのコースをお選びいただくだけで必要な内容を一通り学べます。執事として新たにキャリアを始めたい方、ホテル等で専門性を高めたい方など、幅広い目的に対応する3つのコースをご用意しています。',
  'about.faq.q2': '働きながら通えますか？',
  'about.faq.a2': 'はい。授業は土日開催・完全少人数制（定員6名）のため、お仕事を続けながら受講いただけます。',
  'about.faq.q3': '資料請求や相談はできますか？',
  'about.faq.a3': 'はい。資料請求と個別相談（オンライン可）を無料で承っています。まずはお気軽にお問い合わせください。',

  // CTASection
  'about.cta.label': 'GET STARTED',
  'about.cta.title': 'まずはお気軽にどうぞ',
  'about.cta.body': '資料請求・個別相談は無料です。ご不明な点がございましたら、どのようなことでもお尋ねください。',
  'about.cta.note': '※ご相談はオンラインでも承ります',
  'about.cta.brochure': '資料請求はこちら（無料）',
  'about.cta.consultation': '個別相談を予約する',
  'about.cta.seminar': 'まず1日体験する（体験講座）',

  // RelatedPages section
  'about.related.title': '関連ページ',
  'about.related.subtitleEn': 'Explore Further',
  'about.related.viewLink': '詳しく見る',
  'about.related.coursesLink': 'コース一覧を見る',
  'about.related.link0.title': '教育理念・方針',
  'about.related.link0.desc': '私たちが大切にする教育の考え方',
  'about.related.link1.title': '全日本執事協会について',
  'about.related.link1.desc': '運営母体と提供する事業のご紹介',
  'about.related.link2.title': 'コース一覧・比較',
  'about.related.link2.desc': '3つのコースの違いを一覧で確認',
  'about.related.link3.title': '施設・設備紹介',
  'about.related.link3.desc': 'お台場の本校と実習環境',
  'about.related.link4.title': 'アクセス',
  'about.related.link4.desc': '校舎への行き方と完全予約制のご案内',
  'about.related.link5.title': '学長挨拶',
  'about.related.link5.desc': '学長・執事ベルからのメッセージ',

  // Last updated
  'about.lastUpdated': '最終更新: 2026年7月8日',
};

export default about;
